import { render, staticRenderFns } from "./detalhes.vue?vue&type=template&id=1768db8d&scoped=true&"
import script from "./detalhes.vue?vue&type=script&lang=js&"
export * from "./detalhes.vue?vue&type=script&lang=js&"
import style0 from "./detalhes.vue?vue&type=style&index=0&id=1768db8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768db8d",
  null
  
)

export default component.exports